import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import { ExternalLink } from "components/common";
const StyledAlert = styled(Alert)(
  () => css`
    margin-top: 0;
  `
);
const StyledOl = styled.ol(
  ({ theme }) => css`
    padding-left: 20px;

    > li {
      margin-bottom: ${theme.spacings.sm};
    }

    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const GcsRepositorySetupInfo = () => {
  const productName = useProductName();
  const { t } = useTranslation("enterprise_data_tiering");
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", title: t("gcs_setup.title") }, /* @__PURE__ */ React.createElement(StyledOl, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcs_setup.create_bucket",
      components: {
        bucketsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/storage/docs/creating-buckets" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcs_setup.create_service_account",
      components: {
        serviceAccountsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/iam/docs/service-account-overview" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("gcs_setup.add_key")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcs_setup.give_access",
      values: { productName },
      components: {
        adcLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/docs/authentication/provide-credentials-adc#how-to" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("gcs_setup.enter_bucket"))));
};
export default GcsRepositorySetupInfo;
